import React from 'react'

const RecordVideoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    {...props}
  >
    <path
      d='M9.41121 24.2025H21.0779V19.5358L26.9112 24.2025V12.5358L21.0779 17.2025V12.5358H9.41121V24.2025ZM6.49455 30.0358C5.69246 30.0358 5.00583 29.7503 4.43465 29.1791C3.86347 28.6079 3.57788 27.9213 3.57788 27.1192V9.61918C3.57788 8.8171 3.86347 8.13047 4.43465 7.55929C5.00583 6.9881 5.69246 6.70251 6.49455 6.70251H29.8279C30.63 6.70251 31.3166 6.9881 31.8878 7.55929C32.459 8.13047 32.7446 8.8171 32.7446 9.61918V27.1192C32.7446 27.9213 32.459 28.6079 31.8878 29.1791C31.3166 29.7503 30.63 30.0358 29.8279 30.0358H6.49455Z'
      fill='currentcolor'
    />
  </svg>
)

export default RecordVideoIcon
